import { claimSettlementTypeDef } from "../../../enumeration/definitions/claim-settlement-type-def";

export const taskListTaskTypeDef = `
  id
  authorType
  canBeEdited
  changedAt
  claimSettlementType {
    ${claimSettlementTypeDef}
  }
  createdAt
  taskFileGroupsMissingCount
  image {
    id
    thumbnails {
      type
      src
    }
  }
  internalCode
  insuranceCompany {
    id
    name
  }
  partner {
    id
    name
  }
  state {
    id
    name
  }
  type
  updatedAt
`;
